// LLM generated - Model Claude 4 Sonnet
import { Stack } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';
import { Routes } from '~/domains/common/constants/routes';
import { Button } from '~/domains/design-system/Button';
import { Title } from '~/domains/design-system/Title';

import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';

import type { Notification } from '../notifications.types';
import { CommissionerPostMessageContent } from './CommissionerPostMessageContent';
import { useStyles } from './NotificationInfoModal.styles';

type NotificationInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  notification: Notification;
  isCloseDisabled?: boolean;
  isClosing?: boolean;
};

function NotificationInfoModal({
  isOpen,
  onClose,
  notification,
  isCloseDisabled = false,
  isClosing = false,
}: NotificationInfoModalProps) {
  const { t } = useTranslation('notifications');
  const { classes, theme } = useStyles();
  const isMobile = useIsMobile();
  const router = useRouter();

  // Use contest name as title if available, otherwise use default
  const modalTitle =
    (notification.payload &&
      'contest' in notification.payload &&
      notification.payload.contest?.name) ||
    t('notifications.modals.commissionerPost.title');
  const contestId =
    notification.payload && 'contest' in notification.payload && notification.payload.contest?.id;

  const handleGoToContest = () => {
    if (contestId) {
      router.push(Routes.brazeGamecenter(contestId));
      onClose();
    }
  };

  return (
    <Dialog
      onClose={onClose}
      isOpen={isOpen}
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      className={classes.container}
    >
      <DialogBody className={classes.scrollableContent}>
        <Stack spacing={theme.other.spacing._16} pt={isMobile ? theme.other.spacing._16 : 0}>
          <Title tag="h3" variant="headline-large">
            {modalTitle}
          </Title>

          <CommissionerPostMessageContent notification={notification} />

          <Stack spacing={theme.other.spacing._12}>
            {contestId && (
              <Button
                variant="primary-fill"
                size="medium"
                onClick={handleGoToContest}
                disabled={isCloseDisabled || !contestId}
                className={classes.fullWidthButton}
              >
                {t('notifications.modals.commissionerPost.goToContest')}
              </Button>
            )}

            <Button
              variant="tertiary-fill"
              size="medium"
              onClick={onClose}
              disabled={isCloseDisabled}
              className={classes.fullWidthButton}
            >
              {t('notifications.modals.commissionerPost.close')}
            </Button>
          </Stack>
        </Stack>
      </DialogBody>
    </Dialog>
  );
}

export default NotificationInfoModal;
